module.exports = __webpack_public_path__ + "static/media/ens-fund-i.aaf4177d.png";